import { render, staticRenderFns } from "./AppToolTip.vue?vue&type=template&id=b64a7ed4&scoped=true"
import script from "./AppToolTip.vue?vue&type=script&lang=js"
export * from "./AppToolTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64a7ed4",
  null
  
)

export default component.exports